"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_select_1 = __importDefault(require("react-select"));

var config_1 = require("../config");

var Input_1 = require("../Input");

var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));

var SelectWithSearch =
/** @class */
function (_super) {
  __extends(SelectWithSearch, _super);

  function SelectWithSearch(props) {
    var _this = _super.call(this, props) || this;

    _this.updateLocale = function () {
      _this.forceUpdate();
    };

    LocaleProvider_1.default.on(_this.updateLocale);
    return _this;
  }

  SelectWithSearch.prototype.componentWillUnmount = function () {
    LocaleProvider_1.default.off(this.updateLocale);
  };

  SelectWithSearch.prototype.render = function () {
    var localization = LocaleProvider_1.default.locs.select;
    var _a = this.props,
        className = _a.className,
        disabled = _a.disabled,
        options = _a.options,
        placeholder = _a.placeholder,
        noOptionsMessage = _a.noOptionsMessage,
        onChange = _a.onChange,
        value = _a.value,
        variant = _a.variant;
    var b = config_1.block('select_with_search');

    var noOptionsDefaultMessage = function noOptionsDefaultMessage() {
      return localization.empty;
    };

    var cn = b({
      grey: variant === Input_1.InputVariant.Grey,
      white: variant === Input_1.InputVariant.White
    }).mix(className);
    return react_1.default.createElement(react_select_1.default, {
      maxMenuHeight: 200,
      isSearchable: true,
      isMulti: false,
      isDisabled: disabled,
      options: options,
      onChange: onChange,
      value: value,
      noOptionsMessage: noOptionsMessage || noOptionsDefaultMessage,
      placeholder: placeholder || localization.select,
      className: cn,
      classNamePrefix: b()
    });
  };

  SelectWithSearch.defaultProps = {
    variant: Input_1.InputVariant.Grey
  };
  return SelectWithSearch;
}(react_1.default.Component);

exports.default = SelectWithSearch;